import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { AdminDashboardScreen } from '@/routes/admin/admin-dashboard-screen';

// =============================================================================
// admin-dashboard-route.tsx — Adaptateur routeur de l'écran A-02 « Dashboard global ».
// =============================================================================
// Lie la navigation (TanStack Router) au composant de présentation (testable hors
// routeur). Depuis le registre des opérations (Zone 2), ouvre le détail d'une campagne
// (« /admin/campaigns/$campaignId »). Aucune règle métier ici — la présentation reste
// testable sans routeur (parité campaigns-list-route / campaign-monitoring-route).

export function AdminDashboardRoute(): React.JSX.Element {
  const navigate = useNavigate();

  const onOpen = React.useCallback(
    (campaignId: string): void => {
      void navigate({
        to: '/admin/campaigns/$campaignId',
        params: { campaignId },
      });
    },
    [navigate],
  );

  return <AdminDashboardScreen onOpen={onOpen} />;
}
